import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextHotelFilter = () => {
  const { t } = useTranslation(i18nNS.common);

  const filtersMap = {
    5: {
      name: t('common:HotelFilter.5Star'),
      nameAsItem: t('common:HotelFilter.All5Star'),
    },
    4: {
      name: t('common:HotelFilter.4Star'),
      nameAsItem: t('common:HotelFilter.All4Star'),
    },
    3: {
      name: t('common:HotelFilter.3Star'),
      nameAsItem: t('common:HotelFilter.All3Star'),
    },
    2: {
      name: t('common:HotelFilter.2Star'),
      nameAsItem: t('common:HotelFilter.All2Star'),
    },
    star: {
      name: t('common:HotelFilter.FilterByStars'),
    },
    neiborhood: {
      name: t('common:HotelFilter.FilterByNeighborhood'),
    },
    group: {
      name: t('common:HotelFilter.Neighborhood'),
    },
  };

  return [filtersMap];
};

export default useTextHotelFilter;
